import { useCallback } from 'react';
import { COMPANY_MEMBERS_QUERY_KEY, CUSTOMER_QUERY_KEY } from 'src/constants/query';
import { EXPANDED_ROWS_LIMIT } from 'src/constants/table';
import useInfiniteFetch from 'src/queries/useInfiniteFetch';
import CustomerService from 'src/services/customer.service';
import useQueryData from 'src/queries/useQueryData';
import { customerIdSelector } from 'src/selectors/customer';

const useFetchCompanyMembers = () => {
  const customerId = useQueryData(CUSTOMER_QUERY_KEY, customerIdSelector);

  const fetchFunction = useCallback(
    ({ page, limit }) =>
      CustomerService.getCompanyMembers({
        page,
        limit,
        customerId,
      }),
    [customerId],
  );

  const response = useInfiniteFetch({
    queryKey: [COMPANY_MEMBERS_QUERY_KEY, customerId],
    fetchFunction,
    expandedRowsLimit: EXPANDED_ROWS_LIMIT,
    itemName: 'companyMembers',
  });

  return response;
};

export default useFetchCompanyMembers;
